// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Rubik:wght@400;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recipe-preview-container {
  background-color: white;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 25px;
  padding-bottom: 15px;
  padding-left: 0px !important;
  padding-right: 0px !important;
  margin-top: 10px;
  width: 96% !important;
  word-break: break-word;
}
.recipe-preview-container .container-img-recipe {
  width: 100%;
  max-height: 350px;
  margin-bottom: 25px;
  padding-left: 0px !important;
  padding-right: 0px !important;
  margin-left: 0px !important;
  margin-right: 0px !important;
}
.recipe-preview-container .recipe-content-detail {
  background-color: rgba(0, 0, 0, 0) !important;
  flex: 1 1;
  justify-content: space-between;
  align-items: flex-start;
  align-content: flex-start;
  margin-bottom: 20px;
}
.recipe-preview-container .recipe-left {
  background-color: white !important;
  align-self: flex-start;
  font-size: 15px;
  font-family: Rubik;
  padding-bottom: 50px;
  padding-top: 10px;
}
.recipe-preview-container .recipe-left h3 {
  margin-bottom: 25px;
}
.recipe-preview-container .recipe-left h5 {
  padding-right: 0 !important;
  padding-left: 0 !important;
  margin-right: 0 !important;
  margin-left: 0 !important;
  margin-bottom: 25px;
}
.recipe-preview-container .recipe-left h6 {
  margin-bottom: 25px;
}
.recipe-preview-container .recipe-left p {
  font-size: 16px !important;
}
.recipe-preview-container .recipe-left li {
  font-size: 16px !important;
}
.recipe-preview-container .recipe-right {
  background-color: white !important;
  align-self: flex-start;
}
.recipe-preview-container .box-print {
  background-color: white;
  padding: 10px;
  margin: 10px;
  border: 3px solid #1a1919;
  border-radius: 5px;
  display: flex;
  align-items: center;
  align-content: "center";
  justify-content: space-between;
  align-self: center;
  cursor: pointer;
}
.recipe-preview-container .box-data {
  background-color: #f9f2f4;
  padding-block: 35px;
  margin: 10px;
  border-radius: 5px;
  width: 100%;
}
.recipe-preview-container .box-data h3 {
  margin-bottom: 25px;
}
.recipe-preview-container .box-data h5 {
  padding-right: 0 !important;
  padding-left: 0 !important;
  margin-right: 0 !important;
  margin-left: 0 !important;
  margin-bottom: 25px;
}
.recipe-preview-container .box-data h6 {
  margin-bottom: 25px;
}
.recipe-preview-container .box-data p {
  font-size: 16px !important;
}
.recipe-preview-container .box-data li {
  font-size: 16px !important;
}
.recipe-preview-container .label {
  text-align: center;
  align-self: center;
  text-transform: uppercase;
  font-size: 13px;
  font-family: Rubik;
}
@media print {
  .recipe-preview-container .box-print {
    display: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/views/recipe/recipePreview/recipePreview.scss"],"names":[],"mappings":"AAEA;EACE,uBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,4BAAA;EACA,6BAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;AAAF;AAGC;EACC,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,4BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;AADF;AAIC;EACC,6CAAA;EACA,SAAA;EACA,8BAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;AAFF;AAKC;EACC,kCAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;AAHF;AAKE;EACC,mBAAA;AAHH;AAME;EACC,2BAAA;EACA,0BAAA;EACA,0BAAA;EACA,yBAAA;EACA,mBAAA;AAJH;AAOE;EACC,mBAAA;AALH;AAQE;EACC,0BAAA;AANH;AASE;EACC,0BAAA;AAPH;AAWC;EACC,kCAAA;EACA,sBAAA;AATF;AAYC;EACC,uBAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;AAVF;AAaC;EACC,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAXF;AAaE;EACC,mBAAA;AAXH;AAcE;EACC,2BAAA;EACA,0BAAA;EACA,0BAAA;EACA,yBAAA;EACA,mBAAA;AAZH;AAeE;EACC,mBAAA;AAbH;AAgBE;EACC,0BAAA;AAdH;AAiBE;EACC,0BAAA;AAfH;AAmBC;EACC,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;AAjBF;AAoBC;EACC;IACC,wBAAA;EAlBD;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Rubik:wght@400;600&display=swap\");\n\n.recipe-preview-container {\n  background-color: white;\n  flex-direction: column;\n  justify-content: center;\n  margin-bottom: 25px;\n  padding-bottom: 15px;\n  padding-left: 0px !important;\n  padding-right: 0px !important;\n  margin-top: 10px;\n  width: 96% !important;\n  word-break: break-word;\n\n\t\n\t.container-img-recipe {\n\t\twidth: 100%;\n\t\tmax-height: 350px;\n\t\tmargin-bottom: 25px;\n\t\tpadding-left: 0px !important;\n\t\tpadding-right: 0px !important;\n\t\tmargin-left: 0px !important;\n\t\tmargin-right: 0px !important;\n\t}\n\n\t.recipe-content-detail {\n\t\tbackground-color: rgba(0,0,0,0) !important;\n\t\tflex: 1;\n\t\tjustify-content: space-between;\n\t\talign-items: flex-start;\n\t\talign-content: flex-start;\n\t\tmargin-bottom: 20px;\n\t}\n\n\t.recipe-left {\n\t\tbackground-color: white !important;\n\t\talign-self: flex-start;\n\t\tfont-size: 15px;\n\t\tfont-family: Rubik;\n\t\tpadding-bottom: 50px;\n\t\tpadding-top: 10px;\n\n\t\th3 {\n\t\t\tmargin-bottom: 25px;\n\t\t}\n\n\t\th5 {\n\t\t\tpadding-right: 0 !important;\n\t\t\tpadding-left: 0 !important;\n\t\t\tmargin-right: 0 !important;\n\t\t\tmargin-left: 0 !important;\n\t\t\tmargin-bottom: 25px;\n\t\t}\n\n\t\th6 {\n\t\t\tmargin-bottom: 25px;\n\t\t}\n\n\t\tp {\n\t\t\tfont-size: 16px !important;\n\t\t}\n\n\t\tli {\n\t\t\tfont-size: 16px !important;\n\t\t}\n\t}\n\n\t.recipe-right {\n\t\tbackground-color: white !important;\n\t\talign-self: flex-start;\n\t}\n\n\t.box-print {\n\t\tbackground-color: white;\n\t\tpadding: 10px;\n\t\tmargin: 10px;\n\t\tborder: 3px solid #1a1919;\n\t\tborder-radius: 5px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\talign-content: \"center\";\n\t\tjustify-content: space-between;\n\t\talign-self: center;\n\t\tcursor: pointer;\n\t}\n\n\t.box-data {\n\t\tbackground-color: #f9f2f4;\n\t\tpadding-block: 35px;\n\t\tmargin: 10px;\n\t\tborder-radius: 5px;\n\t\twidth: 100%;\n\n\t\th3 {\n\t\t\tmargin-bottom: 25px;\n\t\t}\n\n\t\th5 {\n\t\t\tpadding-right: 0 !important;\n\t\t\tpadding-left: 0 !important;\n\t\t\tmargin-right: 0 !important;\n\t\t\tmargin-left: 0 !important;\n\t\t\tmargin-bottom: 25px;\n\t\t}\n\n\t\th6 {\n\t\t\tmargin-bottom: 25px;\n\t\t}\n\n\t\tp {\n\t\t\tfont-size: 16px !important;\n\t\t}\n\n\t\tli {\n\t\t\tfont-size: 16px !important;\n\t\t}\n\t}\n\n\t.label {\n\t\ttext-align: center;\n\t\talign-self: center;\n\t\ttext-transform: uppercase;\n\t\tfont-size: 13px;\n\t\tfont-family: Rubik;\n\t}\n\n\t@media print {\n\t\t.box-print {\n\t\t\tdisplay: none !important;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
